import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import {
  ASSOCIATE_CHANGE,
  DEFAULT_LANGUAGE_CHANGE,
  LANGUAGE_TOGGLE,
  LANGUAGES_REQUEST_ASYNC,
  NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS,
  SAVE_LANGUAGE_FROM_TAGS_TOGGLE,
  SET_TAGS_AND_SEGMENTS_PAGE,
  SET_TAGS_AND_SEGMENTS_SEARCH,
  TAGS_AND_SEGMENTS_REQUEST_ASYNC,
  UPDATE_LANGUAGES_ASYNC,
} from './constants'

const defaultTagsAndSegmentsObject = {
  items: {},
  page: 1,
  search: '',
  loader: false,
  error: null,
  totalPages: 1,
}

export default function () {
  const initialState = {
    loader: false,
    languages: [],
    error: null,
    tagsAndSegments: {
      ...defaultTagsAndSegmentsObject,
    },
    selectedTagsOrSegments: {},
    saveLanguageFromTags: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case COMPANY_FILTER_CHANGE:
      case LANGUAGES_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case LANGUAGES_REQUEST_ASYNC.SUCCESS: {
        const initialSelectedProperty = {}
        action.payload.data.languages
          .filter((l) => l.associate)
          .map((elem) =>
            elem.associate.tag
              ? (initialSelectedProperty[elem.associate.tag] = true)
              : (initialSelectedProperty[
                  elem.associate.segment + NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS
                ] = true)
          )
        return {
          ...state,
          languages: action.payload.data.languages,
          loader: false,
          selectedTagsOrSegments: initialSelectedProperty,
          saveLanguageFromTags: action.payload.data.saveLanguageFromTags,
        }
      }
      case LANGUAGES_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case LANGUAGES_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case DEFAULT_LANGUAGE_CHANGE:
        return {
          ...state,
          languages: state.languages.map((elem) =>
            action.payload.id === elem.id
              ? { ...elem, default: true, enabled: true }
              : { ...elem, default: false }
          ),
          loader: false,
        }
      case LANGUAGE_TOGGLE:
        return {
          ...state,
          languages: state.languages.map((elem) =>
            action.payload.id === elem.id
              ? {
                  ...elem,
                  enabled: elem.default ? true : !elem.enabled,
                  associate: elem.default ? elem.associate : undefined,
                }
              : elem
          ),
          selectedTagsOrSegments: {
            ...state.selectedTagsOrSegments,
            [action.payload.associatedId]: undefined,
          },
          loader: false,
        }
      case SAVE_LANGUAGE_FROM_TAGS_TOGGLE:
        return { ...state, saveLanguageFromTags: action.payload.val }
      case TAGS_AND_SEGMENTS_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            loader: true,
            error: null,
          },
        }
      case TAGS_AND_SEGMENTS_REQUEST_ASYNC.SUCCESS: {
        const tags = action.payload.data.tags.tags.reduce((acc, tag) => {
          acc[tag.id] = {
            name: `${tag.name} (TAG)`,
            type: tag.auto_tag_type,
            id: tag.id,
          }
          return acc
        }, {})

        const segments = action.payload.data.segments.segments.reduce((acc, segment) => {
          const id = segment.id + NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS
          acc[id] = {
            name: `${segment.name} (SEGMENT)`,
            type: segment.auto_tag_type,
            id,
          }
          return acc
        }, {})

        const existingItems = state.tagsAndSegments.items || {}

        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            totalPages: action.payload.data.last_page,
            loader: false,
            items: {
              ...existingItems,
              ...tags,
              ...segments,
            },
          },
        }
      }
      case TAGS_AND_SEGMENTS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            loader: false,
            error: action.error,
          },
        }
      case TAGS_AND_SEGMENTS_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            loader: false,
          },
        }
      case SET_TAGS_AND_SEGMENTS_PAGE:
        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            page: action.payload.page,
          },
        }
      case SET_TAGS_AND_SEGMENTS_SEARCH:
        return {
          ...state,
          tagsAndSegments: {
            ...state.tagsAndSegments,
            search: action.payload.search,
          },
        }
      case ASSOCIATE_CHANGE: {
        if (action.payload.id) {
          const thisIsSegment = action.payload.id > NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS
          const id = thisIsSegment
            ? action.payload.id - NUM_FOR_DISTINGUISH_TAGS_AND_SEGMENTS
            : action.payload.id
          return {
            ...state,
            languages: state.languages.map((elem) =>
              action.payload.langId === elem.id
                ? {
                    ...elem,
                    associate: thisIsSegment ? { segment: id } : { tag: id },
                  }
                : elem
            ),
            selectedTagsOrSegments: {
              ...state.selectedTagsOrSegments,
              [action.payload.id]: true,
            },
          }
        }

        return {
          ...state,
          languages: state.languages.map((elem) =>
            action.payload.langId === elem.id
              ? {
                  ...elem,
                  associate: undefined,
                }
              : elem
          ),
          selectedTagsOrSegments: {
            ...state.selectedTagsOrSegments,
            [action.payload.initId]: undefined,
          },
        }
      }
      case UPDATE_LANGUAGES_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case UPDATE_LANGUAGES_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          error: null,
        }
      case UPDATE_LANGUAGES_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_LANGUAGES_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
